import 'react-quill/dist/quill.snow.css';
import { Dispatch, SetStateAction } from 'react';

import ReactQuill from 'react-quill';
import { useFormContext } from 'react-hook-form';
import { TextField } from '@mui/material';

import { TextareaEditorSection } from './styled';
import { myColors } from './data';

interface TextareaEditorProps {
  name: string;
  label: string;
  setValue: any;
  value: string | null;
  error?: string;
}

const TextareaEditor = ({
  name,
  label,
  value,
  setValue,
  error,
}: TextareaEditorProps) => {
  const modules = {
    toolbar: [
      // [{ header: [1, 3] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      // [{ align: ['right', 'center', 'justify'] }],
      // [{ list: 'ordered' }, { list: 'bullet' }],
      // ['link'],
      // [{ color: myColors }],
      // [{ background: myColors }],
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'link',
    'color',
    'image',
    'background',
    'align',
  ];

  return (
    <div>
      <TextareaEditorSection>
        <h5>{label}</h5>
        <ReactQuill
          modules={modules}
          value={value || ''}
          placeholder=""
          formats={formats}
          onChange={(event) => {
            const isEmpty = event.replace(/(<([^>]+)>)/gi, '');

            setValue(name, !isEmpty.length ? '' : event);
          }}
        />
        {error && <p>{error}</p>}

      </TextareaEditorSection>
    </div>
  );
};

export default TextareaEditor;
